export default "__VITE_ASSET__036c6609__"